import { Modal as AntdModal, Divider } from "antd";
import { color } from "src/styles/globals";
import styled from "styled-components";
import { Title as SundayTitle } from "sunday-component";
import CommonButton from "src/components/Common/Button";
import { down } from "styled-breakpoints";

export const Modal = styled(AntdModal)`
  top: 0;
  margin: 0px;
  padding: 0px;
  max-width: 100vw;
  .ant-modal-header {
    text-align: center;
    border-radius: 16px 16px 0px 0px;
  }

  .ant-modal-body {
    padding: 0px;
    overflow: auto;
  }
  .ant-modal-footer {
    padding: 16px;
  }
  .ant-modal-content {
    border-radius: 16px;
  }
  .ant-scrolling-effect {
    width: 0px;
  }
  ${down("xs")} {
    .ant-modal,
    .ant-modal-content {
      height: 100vh;
      max-width: 100vw;
      margin: 0px;
      top: 0;
      padding: 0px;
    }
    .ant-modal-body {
      border-radius: 0;
      height: calc(100vh - 173px);
      width: 100vw;
    }
    .ant-modal-footer {
      padding: 16px 16px 32px 16px;
      position: fixed;
      bottom: 0;
      width: 100%;
      background: white;
    }
    .ant-modal-content {
      overflow: auto;
      border-radius: 0px;
    }
  }
`;

export const Title = styled(SundayTitle)`
  color: ${color.charcoal10};
`;

export const ButtonTitle = styled(SundayTitle)`
  color: inherit;
`;

export const Content = styled.div`
  margin: 16px;
`;

export const BannerImage = styled.img`
  width: 100%;
  height: auto;
`;

export const ModalBody = styled.div``;

export const Button = styled(CommonButton)`
  padding: 13px 16px;
  height: 48px !important;
`;

export const PopupDivider = styled(Divider)`
  color: ${color.charcoal03};
  margin: 16px 0px;
`;
